/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useRef } from 'react';
import { Typography } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import useTranslate from 'hooks/useTranslate';
import { FormTextField, TextFieldPopover } from 'components/TextField';
import { TextFieldProps } from 'components/TextField/TextField';
import { phoneMask } from 'utils/masks';

const AlternateMobileField: React.FC<TextFieldProps> = props => {
  const t = useTranslate();
  const alternativePhoneRef = useRef<HTMLElement | null>(null);

  return (
    <React.Fragment>
      <Field name="alternativePhone">
        {(fieldProps: FieldProps) => (
          <FormTextField
            // "alternativePhone" is not a real value for autocomplete, but Chrome
            // (depending on version) doesn't respect the value "off". See this bug
            // comment: https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
            id="creditAppAltPhone"
            autoComplete="alternativePhone"
            inputRef={alternativePhoneRef}
            type="tel"
            fieldProps={fieldProps}
            required={false}
            label={t('formLabel.alternativePhone')}
            mask={phoneMask}
            {...props}
          />
        )}
      </Field>

      <TextFieldPopover
        id="alternativePhone"
        textFieldRef={alternativePhoneRef}
      >
        <Typography variant="body2">
          {t('creditApplication.phoneAgreement')}
        </Typography>
      </TextFieldPopover>
    </React.Fragment>
  );
};

export default AlternateMobileField;
